
import { useFreemiumLimits } from "@/hooks/useFreemiumLimits";

interface UpgradePromptManagerProps {
  triggerType?: 'project' | 'client' | 'manual';
  onClose?: () => void;
}

export function UpgradePromptManager({ triggerType, onClose }: UpgradePromptManagerProps) {
  const { data: limits } = useFreemiumLimits();

  // Since everything is now free, no upgrade prompts are needed
  // This component is kept for backward compatibility but does nothing
  return null;
}
